import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { grey } from 'theme/colors';
import { styled } from '@mui/material/styles';

function CheckedIcon() {
  return (
    <FontAwesomeIcon icon={faCheckSquare} color='#223559' /> // useStyles not working with SSR here
  );
}

function UncheckedIcon() {
  return <FontAwesomeIcon icon={faSquare} color={grey[700]} />;
}

const renderToStatic = (node: React.ReactNode) =>
  `data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(node))}`;

const renderCheck = () => renderToStatic(<CheckedIcon />);

const renderUnchecked = () => renderToStatic(<UncheckedIcon />);

export const StyledLabel = styled('label')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2em',
  height: '2em',
}));

export const StyledInput = styled('input')(() => ({
  display: 'none',
  '&:checked + span': {
    width: '2em',
    height: '2em',
    background: `url(${renderCheck()}) no-repeat center`,
  },
  '&:disabled + span': {
    opacity: 0.3,
  },
}));

export const StyledSpan = styled('span')(() => ({
  background: `url(${renderUnchecked()}) no-repeat center`,
  display: 'inline-flex',
  width: '2em',
  height: '2em',
  cursor: 'pointer',
}));

export default function CheckboxNative(props) {
  return (
    <StyledLabel>
      <StyledInput type='checkbox' {...props} />
      <StyledSpan />
    </StyledLabel>
  );
}
